import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes = [
  {
    path: "/",
    name: "Accueil",
    component: HomeView,
    meta: {
      title: "Jouez sur votre instrument favori",
    },
  },
  {
    path: "/cours",
    name: "Cours",
    component: () =>
      import(/* webpackChunkName: "cours" */ "../views/ClassesView.vue"),
    meta: {
      title: "Nos cours de musique",
    },
  },
  {
    path: "/ecoles",
    name: "Ecoles",
    component: () =>
      import(/* webpackChunkName: "cours" */ "../views/SchoolsView.vue"),
    meta: {
      title: "Nos écoles de musique",
    },
  },
  {
    path: "/concours-amf",
    name: "ConcoursAMF",
    component: () =>
      import(
        /* webpackChunkName: "cours" */ "../views/Contests/PresentationView.vue"
      ),
    meta: {
      title: "Concours AMF",
    },
  },
  {
    path: "/resultats-eliminatoires-amf-2022",
    name: "EliminatoiresAMF2022",
    component: () =>
      import(
        /* webpackChunkName: "cours" */ "../views/Contests/Playoffs2022View.vue"
      ),
    meta: {
      title: "Résultats Éliminatoires AMF 2022",
    },
  },
  {
    path: "/resultats-eliminatoires-amf-2023",
    name: "EliminatoiresAMF2023",
    component: () =>
      import(
        /* webpackChunkName: "cours" */ "../views/Contests/Playoffs2023View.vue"
      ),
    meta: {
      title: "Résultats Éliminatoires AMF 2023",
    },
  },
  {
    path: "/resultats-eliminatoires-amf-2025",
    name: "EliminatoiresAMF2025",
    component: () =>
      import(
        /* webpackChunkName: "cours" */ "../views/Contests/Playoffs2025View.vue"
      ),
    meta: {
      title: "Résultats Éliminatoires AMF 2025",
    },
  },
  {
    path: "/resultats-eliminatoires-amf-2026",
    name: "EliminatoiresAMF2026",
    component: () =>
      import(
        /* webpackChunkName: "cours" */ "../views/Contests/Playoffs2026View.vue"
      ),
    meta: {
      title: "Résultats Éliminatoires AMF 2026",
    },
  },
  {
    path: "/resultats-finales-amf-2021",
    name: "FinalesAMF2021",
    component: () =>
      import(
        /* webpackChunkName: "cours" */ "../views/Contests/Finals2021View.vue"
      ),
    meta: {
      title: "Résultats Finales AMF 2021",
    },
  },
  {
    path: "/resultats-finales-amf-2022",
    name: "FinalesAMF2022",
    component: () =>
      import(
        /* webpackChunkName: "cours" */ "../views/Contests/Finals2022View.vue"
      ),
    meta: {
      title: "Résultats Finales AMF 2022",
    },
  },
  {
    path: "/resultats-finales-amf-2023",
    name: "FinalesAMF2023",
    component: () =>
      import(
        /* webpackChunkName: "cours" */ "../views/Contests/Finals2023View.vue"
      ),
    meta: {
      title: "Résultats Finales AMF 2023",
    },
  },
  {
    path: "/resultats-finales-amf-2024",
    name: "FinalesAMF2024",
    component: () =>
      import(
        /* webpackChunkName: "cours" */ "../views/Contests/Finals2024View.vue"
      ),
    meta: {
      title: "Résultats Finales AMF 2024",
    },
  },
  {
    path: "/resultats-finales-amf-2025",
    name: "FinalesAMF2025",
    component: () =>
      import(
        /* webpackChunkName: "cours" */ "../views/Contests/Finals2025View.vue"
      ),
    meta: {
      title: "Résultats Finales AMF 2025",
    },
  },
  {
    path: "/laureats-amf",
    name: "LaureatsAMF",
    component: () =>
      import(
        /* webpackChunkName: "cours" */ "../views/Contests/WinnersView.vue"
      ),
    meta: {
      title: "Tous nos Lauréats du Concours AMF",
    },
  },
  {
    path: "/contactez-nous",
    name: "ContactezNous",
    component: () =>
      import(/* webpackChunkName: "cours" */ "../views/ContactUsView.vue"),
    meta: {
      title: "Contactez-nous",
    },
  },
  {
    path: "/mentions-legales",
    name: "MentionsLegales",
    component: () =>
      import(/* webpackChunkName: "cours" */ "../views/LegalView.vue"),
    meta: {
      title: "Mentions légales",
    },
  },
  {
    path: "/:catchAll(.*)",
    name: "PageNonTrouvee",
    component: () =>
      import(/* webpackChunkName: "cours" */ "../views/NotFound.vue"),
    meta: {
      title: "Page non trouvée",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

router.beforeEach((to, _from, next) => {
  document.title = `${to.meta.title} - École de Musique Muller`;
  next();
});

export default router;
